import React from "react";
import {Badge, DataTableColumnProps, Icon} from "peggirkit";
import {FormattedMessage, IntlShape} from "react-intl";
import {LoyaltyRewardDetails} from "@/data/entities/loyaltyReward";
import BadgeIconIndicator from "peggirkit/dist/components/Badge/BadgeElements/Indicator/BadgeIconIndicator";
import {CheckCircleIcon, ExclamationCircleIcon} from "@heroicons/react/16/solid";
import OptionsFormatter from "@widgets/loyaltyRewards/overview/table/OptionsFormatter";
import {Bars4Icon} from "@heroicons/react/24/solid";
import {SetStateFn} from "@/utils/SetStateUtils";
import {DeleteLoyaltyRewardState} from "@widgets/loyaltyRewards/delete/DeleteLoyaltyRewardModal";
import {ProductReference} from "@/data/entities/product";

export const getLoyaltyRewardsTableColumns = (
    intl: IntlShape,
    DeleteLoyaltyRewardState: SetStateFn<DeleteLoyaltyRewardState>,
): DataTableColumnProps<LoyaltyRewardDetails>[] => ([
    {
        id: "id",
        label: {
            displayName: intl.formatMessage({id: "id"}),
            hide: true,
        },
        primary: false,
        tdClassname: "w-5",
        thClassname: "w-5",
        formatter: () => <Icon className="size-5" icon={Bars4Icon}/>,
    },
    {
        id: "product",
        label: {displayName: intl.formatMessage({id: "loyaltyReward"})},
        primary: true,
        formatter: (product: ProductReference | null) => product === null
            ? (
                <Badge
                    color={"danger"}
                    size={"xs"}
                    indicator={<BadgeIconIndicator icon={ExclamationCircleIcon}/>}
                >
                    <FormattedMessage id={"doesNotExistAnymore"}/>
                </Badge>
            )
            : product.name,
    },
    {
        id: "requiredPoints",
        label: {displayName: intl.formatMessage({id: "requiredPoints"})},
        primary: false,
        align: "right",
    },
    {
        id: "active",
        label: {displayName: intl.formatMessage({id: "status"})},
        primary: false,
        align: "right",
        formatter: (active: boolean) => (
            <Badge
                color={active ? "success" : "warning"}
                size={"xs"}
                indicator={<BadgeIconIndicator icon={active ? CheckCircleIcon : ExclamationCircleIcon}/>}
            >
                <FormattedMessage id={active ? "active" : "deactivated"}/>
            </Badge>
        ),
    },
    {
        id: "productExternalId",
        label: {
            displayName: intl.formatMessage({id: "view"}),
            hide: true,
        },
        primary: false,
        sortingConfig: {
            enabled: false,
        },
        align: "right",
        formatter: (_, loyaltyReward) => (
            <OptionsFormatter
                deleteLoyaltyRewardState={DeleteLoyaltyRewardState}
                loyaltyReward={loyaltyReward}
            />
        ),
    },
]);